import angular from 'angular';
import videoModalForYoutube from './videoModalForYoutube';

export default angular
  .module('components.videoModalForYoutube', [])
  .component('videoModalForYoutube', videoModalForYoutube).name;
